module.exports = __webpack_public_path__ + "img/medtronic-logo.7c74207e.png";